import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { css } from 'styled-components';
import { Colors } from 'styles';
import { formatReportSignedByLabel } from 'utils/date';

export type ReportSignedByLabelProps = {
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  sentAt: Date;
};

export const ReportSignedByLabel = ({
  firstName,
  lastName,
  sentAt,
}: ReportSignedByLabelProps): React.ReactElement => {
  const label = formatReportSignedByLabel({ firstName, lastName, sentAt });
  return (
    <Stack alignY="center" data-testid="report-signed-by-label">
      <Text
        variant="caption"
        css={css`
          color: ${Colors.gray8};
          margin-left: 4px;
        `}
      >
        {label}
      </Text>
    </Stack>
  );
};
